"use client"
import {
  Int32StringValueTuple,
  LostFoundColorPublicResponse,
  LostFoundContentPublicResponse,
} from "api"
import { GetPageByRouteQuery } from "apollo"
import { Suspense } from "react"
import { extractProperty, getBreadCrumbs, transformProperties } from "utils"
import DynamicTitle from "../Common/DynamicTitle"
import Hero from "../Common/Hero"
import ContactContent from "./ContactContent"

type Props = {
  data: GetPageByRouteQuery
  locale: "he" | "en" | "ar" | "ru"
  contactTypesData: Int32StringValueTuple[]
  lostFoundContentData: LostFoundContentPublicResponse[]
  lostFoundColorsData: LostFoundColorPublicResponse[]
}

export default function ContactUs({
  data,
  locale,
  contactTypesData,
  lostFoundContentData,
  lostFoundColorsData,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const heroBanner = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const dynamicTitle = blocks?.blocks?.find(
    (block: any) => block.blockType === "adynamicTitleAndContant",
  )
  const contactUs = blocks?.blocks?.find(
    (block: any) => block.blockType === "contactUs",
  )
  const inquiries = blocks?.blocks?.find(
    (block: any) => block.blockType === "InquiriesAndRequests",
  )
  const lost = blocks?.blocks?.find(
    (block: any) => block.blockType === "StatusLost",
  )
  const lostAndFoundStatus = blocks?.blocks?.find(
    (block: any) => block.blockType === "lostAndFoundStatus",
  )

  const tabsData = {
    contactUs: {
      data: contactUs,
      tabTitle: extractProperty(contactUs, "tabTitle"),
    },
    inquiries: {
      data: inquiries,
      tabTitle: extractProperty(inquiries, "tabTitle"),
    },
    lost: {
      data: lost,
      tabTitle: extractProperty(lost, "tabTitle"),
    },
  }

  return (
    <>
      <Hero data={heroBanner} breadCrumbs={breadCrumbs} />
      <DynamicTitle data={dynamicTitle} />
      <Suspense>
        <ContactContent
          tabsData={tabsData}
          contactTypesData={contactTypesData}
          locale={locale}
          lostFoundContentData={lostFoundContentData}
          lostFoundColorsData={lostFoundColorsData}
          lostAndFoundStatus={lostAndFoundStatus}
        />
      </Suspense>
    </>
  )
}
